<template>
  <div class="cabinet-login-box-container">
    <!-- Login Google and Facebook -->
    <!-- <div class="social_buttons">
        <button @click="doFederatedGoogleLogIn">
          <img src="/assets/images/google.png" alt="">
          {{ $t('loginBox.logInGoogle') }}
        </button>
        <button @click="doFederatedFacebookLogIn">
          <img src="/assets/images/facebook.png" alt="">
          {{ $t('loginBox.logInFacebook') }}
        </button>
    </div> -->

    <!-- separator -->
    <!-- <div class="or">
      <div class="or__bar"></div>
      <div class="or__label">{{ $t('loginBox.or') }}:</div>
      <div class="or__bar"></div>
    </div> -->

    <!-- Login Email and Password -->
    <div class="form__group field">
      <input
        type="email"
        id="labelled-field-email"
        name="labelled-field-email"
        class="form__field form__email"
        :placeholder="Email"
        v-model="email"
        @keyup.enter="submit"
      />
      <label for="labelled-field-email" class="form__label">{{
        $t("loginBox.email")
      }}</label>
    </div>

    <div class="form__group field">
      <input
        type="password"
        id="labelled-field-password"
        name="labelled-field-password"
        class="form__field form__email password"
        :placeholder="Password"
        v-model="password"
        @keyup.enter="submit"
      />
      <label for="labelled-field-password" class="form__label">{{
        $t("loginBox.password")
      }}</label>
    </div>

    <button
      class="submit red-button"
      @click="submit"
      :disabled="buttonsAreDisabled"
    >
      {{ $t("loginBox.submit") }}
    </button>
    <!--Button remember password -->
    <button class="forgot" @click="forgot" :disabled="buttonsAreDisabled">
      {{ $t("loginBox.forgot") }}
    </button>
    <!-- Links Sign up and Try a free demo-->
    <p class="linkRegistro">
      <strong>{{ $t("loginBox.doNotAccount") }} </strong>
      <a :href="pageUrl" target="_blank">{{ $t("loginBox.signUp") }}</a>
      {{ $t("loginBox.or") }}
      <a :href="pageUrl2" target="_blank">{{
        $t("loginBox.tryFreeDemo")
      }}</a>
    </p>
  </div>
</template>

<script>
// import LabelledInput from "@/components/LabelledInput";
import { getCurrentInstance, ref } from "@vue/runtime-core";
import store from "@/store";

export default {
  name: "LoginBox",
  props: {
    auto: Boolean,
  },
  data() {
    return {
      pageUrl: process.env.VUE_APP_TRADEVIEW_INDEX + "formIndividual",
      pageUrl2: process.env.VUE_APP_TRADEVIEW_INDEX + "open-demo",
    };
  },
  emits: ["submit", "forgot"],
  setup(props, { emit }) {
    let email = ref(null);
    let password = ref(null);
    let buttonsAreDisabled = ref(false);

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    const lock = () => {
      buttonsAreDisabled.value = true;
    };

    const release = () => {
      buttonsAreDisabled.value = false;
    };

    const clear = () => {
      email.value = null;
      password.value = null;
    };

    const submit = () => {
      if (props.auto != null && props.auto) buttonsAreDisabled.value = true;
      emit("submit", email.value, password.value);
    };

    const forgot = () => {
      if (props.auto != null && props.auto) buttonsAreDisabled.value = true;
      emit("forgot", email.value);
    };

    let regInfo = store.state.userRegistration;

    if (typeof regInfo !== "undefined" && regInfo !== null) {
      // console.log(regInfo)
      // console.log('using ' + regInfo.email + '...')
      email.value = regInfo.email;
    }

    const doFederatedGoogleLogIn = () => {
      emitter.emit("federatedSignIn", {
        provider: "Google",
        code: null,
        token: null,
      });
    };

    const doFederatedFacebookLogIn = () => {
      emitter.emit("federatedSignIn", {
        provider: "Facebook",
        code: null,
        token: null,
      });
    };

    return {
      doFederatedGoogleLogIn,
      doFederatedFacebookLogIn,
      lock,
      release,
      clear,
      submit,
      forgot,
      email,
      password,
      // buttonsAreDisabledf
    };
  },
};
</script>
